import { useState, useEffect, useCallback } from 'react';
import { useHistory, useLocation } from 'quartz-routing/react-router';

/**
 * Hook to help public achievement redirect to canonical url if necessary.
 *
 * actualSlug  - the slug from the current page href
 * replaceSlug - callback to change the page url
 * urlSlug     - the slug associated with the achievement
 */
const useSettledUrl = ({
  actualSlug,
  urlSlug
}) => {
  const [isSettled, setIsSettled] = useState(false);
  const location = useLocation();
  const history = useHistory();
  const replaceSlug = useCallback((actual, url) => {
    history.replace(location.pathname.replace(actual, url));
  }, [history, location.pathname]);
  useEffect(() => {
    if (!isSettled && typeof urlSlug === 'string') {
      if (urlSlug !== actualSlug) {
        replaceSlug(actualSlug, urlSlug);
      }
      setIsSettled(true);
    }
  }, [actualSlug, isSettled, replaceSlug, urlSlug]);
  return isSettled;
};
export default useSettledUrl;